import { useEffect, useState } from "react";
import Product from "./Product";

function AllProducts() {
  const [products, setProducts] = useState([]);

  const getProducts = async () => {
    const response = await fetch("https://fakestoreapi.com/products");
    const data = await response.json();
    setProducts(data);
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className="my-8">
      <div className="grid lg:grid-cols-6 grid-flow-row-dense">
        {products?.map((product) => (
          <Product
            key={product.id}
            img={product.image}
            title={product.title}
            price={product.price}
            discount
            rating={product.rating}
          />
        ))}
      </div>
    </div>
  );
}

export default AllProducts;
